// @flow
import React, {Component} from 'react';

import I18n from '../../../lib/i18n';
import Modal from './Modal';
import ValidationButton from '../ValidationButton';
import {View} from 'react-native';

type Props = {
  ButtonComponent?: any,
  cancelTextKey?: string,
  confirmContent?: string,
  confirmTextKey?: string,
  disabled?: boolean,
  isLoading?: boolean,
  noMargin?: boolean,
  onCancel?: Function,
  onConfirm?: Function,
  openModalText?: string,
  style?: any,
  testID?: string,
  thirdButtonAction?: Function,
  thirdButtonText?: string,
  title?: string,
};

type State = {
  open: boolean,
};

class ConfirmationModal extends Component<Props, State> {
  state = {open: false};

  openModal = () => {
    this.setState({open: true});
  };

  confirm = () => {
    if (this.props.onConfirm) {
      this.props.onConfirm();
    }
    this.setState({open: false});
  };

  cancel = () => {
    if (this.props.onCancel) {
      this.props.onCancel();
    }
    this.setState({open: false});
  };

  render() {
    const {
      ButtonComponent,
      cancelTextKey = I18n.t('cancel'),
      confirmContent,
      confirmTextKey = I18n.t('confirm'),
      disabled,
      isLoading,
      noMargin,
      openModalText,
      style,
      thirdButtonAction,
      thirdButtonText,
      title,
    } = this.props;
    let modalButton;

    if (ButtonComponent) {
      modalButton = React.cloneElement(ButtonComponent, {
        text: openModalText,
        onPress: this.openModal,
        disabled,
        isLoading,
      });
    } else {
      modalButton = (
        <ValidationButton
          testID={this.props.testID}
          text={openModalText || ''}
          onPress={this.openModal}
          disabled={disabled}
          isLoading={isLoading}
          noMargin={noMargin}
        />
      );
    }
    return (
      <View style={style}>
        {modalButton}
        <Modal
          confirmText={confirmTextKey}
          cancelText={cancelTextKey}
          confirm={this.confirm}
          cancel={this.cancel}
          opened={this.state.open}
          confirmContent={confirmContent}
          title={title || I18n.t('confirm')}
          thirdButtonAction={thirdButtonAction}
          thirdButtonText={thirdButtonText}
        />
      </View>
    );
  }
}

export default ConfirmationModal;
